import type { DesignerNodeData } from "../schemas/index.ts";
import type { GetDesignerNodeVersion, GetPlaceholderDataForId, GetTriggerDesigns } from "../state/index.ts";

interface Options {
  getVersion: GetDesignerNodeVersion;
  getPlaceholder: GetPlaceholderDataForId;
  getTriggerDesigns: GetTriggerDesigns;
}

// TODO: does owner/creator belong on portable node? maybe it will go away when that concept is metadata rather than part of node

export const getPortableDesignerNodeCreate =
  ({ getVersion, getPlaceholder, getTriggerDesigns }: Options) =>
  (node: DesignerNodeData): DesignerNodeData => {
    const buildPortableNode = ({
      id,
      typeId,
      role,
      config,
      childNodes,
      isPlaceholder,
      owner,
      creator,
      triggers,
    }: DesignerNodeData): DesignerNodeData => {
      const version = getVersion({ typeId });
      const placeholderNode = getPlaceholder(id);
      const placeholder = placeholderNode ? buildPortableNode(placeholderNode) : undefined;

      return {
        id,
        typeId,
        config,
        role,
        version,
        isPlaceholder,
        childNodes: Object.fromEntries(
          Object.entries(childNodes).map(([name, childOrChildren]) => [
            name,
            Array.isArray(childOrChildren)
              ? childOrChildren.map(buildPortableNode)
              : childOrChildren
                ? buildPortableNode(childOrChildren)
                : undefined,
          ]),
        ),
        placeholder,
        triggers: triggers ?? getTriggerDesigns(id),
        owner,
        creator,
      };
    };

    return buildPortableNode(node);
  };

export type GetPortableDesignerNode = ReturnType<typeof getPortableDesignerNodeCreate>;
